import { render, staticRenderFns } from "./techTask.vue?vue&type=template&id=41bb4ed8&scoped=true"
import script from "./techTask.vue?vue&type=script&lang=js"
export * from "./techTask.vue?vue&type=script&lang=js"
import style0 from "./techTask.vue?vue&type=style&index=0&id=41bb4ed8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41bb4ed8",
  null
  
)

export default component.exports